import React, { useState, useEffect } from 'react';
import { ImagesLoader } from '../../smart/utils/images-loader/ImagesLoader';
import { Loader } from '../utils/loader/Loader';
import './testimonialarea.scss';

type props = {}

export const TestimonialArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {
        return <Loader />;
    }
    else
        return <div className="testmonial_area">
            <div className="container">
                <div className="row">
                    <div className="col-xl-10 offset-xl-1">
                        <div className="testmonial_active2 owl-carousel">
                            <div className="single_slider text-center" data-dot='<img src="img/testmonial/1.png" alt="#" ' >
                                <p>Originariamente parte di Borsa Italiana, è nata nel 1998, con l’obiettivo di sviluppare il business degli Information Services. Dopo la fusione tra London Stock Exchange e Borsa Italiana, avvenuta nel 2007, la divisione è stata rinominata Proquote Italy con l’obiettivo di sviluppare i servizi Market Connect, Investor Relations e Sdir&Storage (piattaforma per la diffusione delle informazioni regolamentate).</p>
                                {/* <div className="author_name text-center">
                                    <h4>Robert Jonson</h4>
                                    <span> Business Owner</span>
                                </div> */}
                            </div>
                            <div className="single_slider text-center" data-dot='<img src="img/testmonial/1.png" alt="#" ' >
                                <p>Nel 2017 è entrara a far parte di Spafid Connect (Gruppo Mediobanca) e i suoi servizio sono stati rinominata in Market Connect.</p>
                                {/* <div className="author_name text-center">
                                    <h4>Robert Jonson</h4>
                                    <span> Business Owner</span>
                                </div> */}
                            </div>
                            <div className="single_slider text-center" data-dot='<img src="img/testmonial/1.png" alt="#" ' >
                                <p>Nel dicembre 2018 Infront ASA ha acquisito il business MARKET CONNECT dal Gruppo Mediobanca, creando la società Infront Italia.</p>
                                {/* <div className="author_name text-center">
                                    <h4>Robert Jonson</h4>
                                    <span> Business Owner</span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
}